const BookIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='31'
			height='31'
			viewBox='0 0 31 31'
			fill='none'>
			<path
				d='M10.5529 2.90625H22.475C23.3365 2.90625 24.2006 3.04704 24.8038 3.67221C25.398 4.28962 25.5104 5.14471 25.5104 5.94167V21.1833C25.5104 21.8847 25.4174 22.5745 25.0583 23.1325C24.8511 23.4543 24.5611 23.7144 24.2187 23.8855V25.0583C24.2187 25.9186 24.0792 26.7827 23.4553 27.3859C22.8379 27.9827 21.9828 28.0938 21.1859 28.0938H7.42704C6.91319 28.0938 6.42037 27.8896 6.05702 27.5263C5.69367 27.1629 5.48954 26.6701 5.48954 26.1562V7.77196C5.48567 7.12871 5.48179 6.32529 5.65746 5.59292C5.87317 4.69908 6.37046 3.83237 7.42833 3.29375C7.86492 3.07158 8.32475 2.98375 8.81558 2.945C9.28704 2.90625 9.86183 2.90625 10.5529 2.90625ZM7.42704 26.1562H21.1859C21.8924 26.1562 22.0681 26.0322 22.1081 25.9935C22.1404 25.9625 22.2812 25.7933 22.2812 25.0583V24.2188H9.36454C8.85069 24.2188 8.35787 24.4229 7.99452 24.7862C7.63117 25.1496 7.42704 25.6424 7.42704 26.1562Z'
				fill='#BF8AFC'
			/>
		</svg>
	);
};

export default BookIcon;
